import React,{useRef, useState, useEffect} from "react";
import Select from "react-select";
import CreatableSelect from 'react-select/creatable';
import {List, SquaresFour, MapTrifold } from "@phosphor-icons/react";
import vindrApi from "../utils/vindrapi";
import authApi from "../utils/authApi";
import TagColor from "../components/TagColor";
import { Col, Row, Form, Nav} from "react-bootstrap";


export default function TagSelector(props) {
	

	const [loaded,setLoaded]			= useState(false); //status variable set when all data is loaded
	const [errors,setErrors]			= useState(new Set()); //what layer to show, default show owners
	const [options,setOptions]			= useState([]); //what layer to show, default show owners
	const [colors,setColors]			= useState([]); //what layer to show, default show owners
	const [tag,setTag]					= useState(props.value ? props.value : {}); //what layer to show, default show owners

	useEffect(()=>{
		getData();
	},[])
	
	const setTagColor = (color) => {
		
		const newTag = {...tag, ...{color:color}};
		
		setTag(newTag);
		
		if(props.onChange)
			props.onChange(newTag);
	} 
	
	const setTagName = (opt) => {
		
		const newTag = opt ? {...tag, ...{name:opt.value}} : {};
		
		setTag(newTag);
		
		if(props.onChange)
			props.onChange(newTag);
	}

	const getData = ()=>{ 
		
		Promise.all([vindrApi.getToken()])
		.then((res) => {
			return Promise.all([authApi.getUser()]);
		})
		.then((res) => {
	
			const dataRequests = [
				vindrApi.getTags(props.projectid),
				vindrApi.getTagColors()
			];
			return Promise.all(dataRequests);
		})
		.then((res)=>{
			
			
			setOptions(res[0].map((t)=>{
				return createOption(t.name);
			}))
			setColors(res[1].map((t)=>{
				return createOption(t.color);
			}))
			
			
		}).catch((e)=>{
			console.log(e);
			
			setLoaded(true);
			setErrors(p => [...p, 'Error fetching data']); //add this error to previous errors
		});
		return;

	};	
	
	const handleCreate = (option) => {

		
		  const newOption = createOption(option);
		  const newTag = {name:option};
		  
		  setOptions((prev) => [...prev, newOption]);
		  setTag(newTag);
		
	}
	const createOption = (label) => ({
	  label,
	  value: (label ? label.toLowerCase().replace(/\W/g, '') : ''),
	});
	return (
		<>
			<Row className="mb-3">
				<Form.Group as={Col} md="12">
					<Form.Label>Tag (optional)</Form.Label>
					<CreatableSelect 
						name="tag"
						isClearable
						options={options} 
						defaultValue={createOption(tag.name)} 
						value={createOption(tag.name)} 
						onChange={setTagName}
						onCreateOption={handleCreate}
						isSearchable={true} 
						placeholder="Start typing..." 
					/>
				</Form.Group>
			</Row>
			{!!tag.name  &&
			<Row>
				<Form.Group as={Col} md="12">
					<Form.Label>Tag color</Form.Label>

					<TagColor value={tag.color} onChange={setTagColor} />
				</Form.Group>
			</Row>
			}
		</>
	)
}